/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Gopay_Return_OkInputs */

const cs_billing_gopay_return_ok = /** @type {(inputs: Billing_Gopay_Return_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platba potvrzena — kredity připsány.`)
};

const en_billing_gopay_return_ok = /** @type {(inputs: Billing_Gopay_Return_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment confirmed — credits posted.`)
};

/**
* | output |
* | --- |
* | "Payment confirmed — credits posted." |
*
* @param {Billing_Gopay_Return_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_gopay_return_ok = /** @type {((inputs?: Billing_Gopay_Return_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Gopay_Return_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_gopay_return_ok(inputs)
	return cs_billing_gopay_return_ok(inputs)
});